import {
  MapDataKind,
  type TalentDiscoveryRespGeoDataV3,
} from '@revelio/data-access';

import { LocationType, type MapPoint } from '../../Chart/Map/types';

const LOCATION_TYPE_BY_MAP_DATA_KIND: Readonly<Record<string, LocationType>> = {
  [MapDataKind.Country]: LocationType.COUNTRY,
  METRO_AREA: LocationType.METRO_AREA,
  [MapDataKind.Msa]: LocationType.METRO_AREA,
  [MapDataKind.State]: LocationType.STATE,
  [MapDataKind.County]: LocationType.COUNTY,
  [MapDataKind.City]: LocationType.CITY,
  CITY_CORE: LocationType.CITY,
};

export const transformTalentDiscoveryMapData = (
  rawMapData:
    | Array<TalentDiscoveryRespGeoDataV3 | null | undefined>
    | null
    | undefined
): MapPoint[] => {
  const result =
    rawMapData
      ?.map((d) => {
        if (!d || !d.lat || !d.lon) return null;

        const locationType =
          LOCATION_TYPE_BY_MAP_DATA_KIND[d.map_data_kind] ?? null;

        return {
          id: String(d.id),
          label: d.location,
          lat: d.lat,
          lon: d.lon,
          value: d.count ?? 0,
          locationType,
          tooltip: { type: d.type, id: d.id },
        } as MapPoint;
      })
      .filter((p): p is MapPoint => p !== null) ?? [];

  return result;
};
